import { render, staticRenderFns } from "./buscaCep.vue?vue&type=template&id=52526cf0"
import script from "./buscaCep.vue?vue&type=script&lang=js"
export * from "./buscaCep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports